import { createGlobalStyle } from 'styled-components';
import {
  circularSpotifyUiLatinOs2V3BookWoff2,
  circularSpotifyUiLatinOs2V3BookWoff,
  circularSpotifyUiLatinOs2V3BookOtf,
  circularSpotifyUiLatinOs2V3BoldWoff2,
  circularSpotifyUiLatinOs2V3BoldWoff,
  circularSpotifyUiLatinOs2V3BoldOtf,
  circularSpotifyUiLatinOs2V3BlackWoff2,
  circularSpotifyUiLatinOs2V3BlackWoff,
  circularSpotifyUiLatinOs2V3BlackOtf,
  circularSpotifyUiArabicBookWoff2,
  circularSpotifyUiArabicBookWoff,
  circularSpotifyUiArabicBookOtf,
  circularSpotifyUiArabicBoldWoff2,
  circularSpotifyUiArabicBoldWoff,
  circularSpotifyUiArabicBoldOtf,
  circularSpotifyUiArabicBlackWoff2,
  circularSpotifyUiArabicBlackWoff,
  circularSpotifyUiArabicBlackOtf,
  circularSpotifyUiHebrewBookWoff2,
  circularSpotifyUiHebrewBookWoff,
  circularSpotifyUiHebrewBookOtf,
  circularSpotifyUiHebrewBoldWoff2,
  circularSpotifyUiHebrewBoldWoff,
  circularSpotifyUiHebrewBoldOtf,
  circularSpotifyUiHebrewBlackWoff2,
  circularSpotifyUiHebrewBlackWoff,
  circularSpotifyUiHebrewBlackOtf,
} from '@spotify-internal/encore-web';

const GlobalFonts = createGlobalStyle`
  @font-face {
    font-family: 'spotify-circular';
    src: url('${circularSpotifyUiLatinOs2V3BookWoff2}') format('woff2'), url('${circularSpotifyUiLatinOs2V3BookWoff}') format('woff'), url('${circularSpotifyUiLatinOs2V3BookOtf}') format('opentype');
    font-weight: 400;
    font-style: normal;
  }
  @font-face {
    font-family: 'spotify-circular';
    src: url('${circularSpotifyUiLatinOs2V3BoldWoff2}') format('woff2'), url('${circularSpotifyUiLatinOs2V3BoldWoff}') format('woff'), url('${circularSpotifyUiLatinOs2V3BoldOtf}') format('opentype');
    font-weight: 700;
    font-style: normal;
  }
  @font-face {
    font-family: 'spotify-circular';
    src: url(${circularSpotifyUiLatinOs2V3BlackWoff2}) format('woff2'), url('${circularSpotifyUiLatinOs2V3BlackWoff}') format('woff'), url('${circularSpotifyUiLatinOs2V3BlackOtf}') format('opentype');
    font-weight: 900;
    font-style: normal;
  }
  @font-face {
    font-family: 'spotify-circular-arabic';
    src: url('${circularSpotifyUiArabicBookWoff2}') format('woff2'), url('${circularSpotifyUiArabicBookWoff}') format('woff'), url('${circularSpotifyUiArabicBookOtf}') format('opentype');
    font-weight: 400;
    font-style: normal;
  }
  @font-face {
    font-family: 'spotify-circular-arabic';
    src: url('${circularSpotifyUiArabicBoldWoff2}') format('woff2'), url('${circularSpotifyUiArabicBoldWoff}') format('woff'), url('${circularSpotifyUiArabicBoldOtf}') format('opentype');
    font-weight: 700;
    font-style: normal;
  }
  @font-face {
    font-family: 'spotify-circular-arabic';
    src: url('${circularSpotifyUiArabicBlackWoff2}') format('woff2'), url('${circularSpotifyUiArabicBlackWoff}') format('woff'), url('${circularSpotifyUiArabicBlackOtf}') format('opentype');
    font-weight: 900;
    font-style: normal;
  }
  @font-face {
    font-family: 'spotify-circular-hebrew';
    src: url('${circularSpotifyUiHebrewBookWoff2}') format('woff2'), url('${circularSpotifyUiHebrewBookWoff}') format('woff'), url('${circularSpotifyUiHebrewBookOtf}') format('opentype');
    font-weight: 400;
    font-style: normal;
  }
  @font-face {
    font-family: 'spotify-circular-hebrew';
    src: url('${circularSpotifyUiHebrewBoldWoff2}') format('woff2'), url('${circularSpotifyUiHebrewBoldWoff}') format('woff'), url('${circularSpotifyUiHebrewBoldOtf}') format('opentype');
    font-weight: 700;
    font-style: normal;
  }
  @font-face {
    font-family: 'spotify-circular-hebrew';
    src: url('${circularSpotifyUiHebrewBlackWoff2}') format('woff2'), url('${circularSpotifyUiHebrewBlackWoff}') format('woff'), url('${circularSpotifyUiHebrewBlackOtf}') format('opentype');
    font-weight: 900;
    font-style: normal;
  }
  :lang(ar) *,
  :lang(ur) * {
    font-family: 'spotify-circular-arabic', 'noto-arabic', 'Helvetica Neue', Helvetica, Arial, 'Hiragino Kaku Gothic Pro', 'Meiryo', 'MS Gothic', sans-serif !important;
    letter-spacing: 0 !important;
  }
  :lang(he) * {
    font-family: 'spotify-circular-hebrew', Helvetica, Arial, sans-serif !important;
    letter-spacing: 0 !important;
  }
  :lang(bn) *,
  :lang(hi) *,
  :lang(ne) * {
    letter-spacing: 0 !important;
  }
  :lang(ko) * {
    word-break: keep-all;
  }
`;

export default GlobalFonts;
